module.exports = __webpack_public_path__ + "assets/img/8_1754_big.46e108a6.jpg";